import { FileSearchOutlined } from '@ant-design/icons';
import './NotFoundPopup.css';

const NotFoundPopup = ({ message }: { message?: string }) => {
  return (
    <div className="content flex flex-col items-center py-[32px]">
      <div className="mb-2 text-[36px] text-[#6c6c6c]">
        <FileSearchOutlined />
      </div>
      <div>{message}</div>
    </div>
  );
};

export default NotFoundPopup;
